/* eslint-disable react/jsx-pascal-case */
import Typography from "../../Typography";
import CompanyData from "../../variables/CompanyData";
import { useState, useEffect } from "react";
import NavBarList from "../../variables/NavBarList";

const comp = CompanyData[0];

function NavBarT1() {
  const Socm = ({ children, label, url }) => {
    return (
      <a
        href={url}
        className="flex items-center justify-center hover:opacity-50 transition-opacity duration-300 ease-in-out"
        title={label}
      >
        {children}
        <span>{label}</span>
      </a>
    );
  };

  const NavUrl = ({ children, url, dropdownItems }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    // Check if the screen width is below the 'md' breakpoint
    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= 768); // md breakpoint is 768px
      };

      window.addEventListener("resize", handleResize);
      handleResize(); // Initial check on component mount

      return () => window.removeEventListener("resize", handleResize);
    }, []);

    const toggleDropdown = (e) => {
      if (isMobile) {
        e.preventDefault(); // Prevent page reload on mobile when clicking the dropdown
        setIsOpen(!isOpen);
      }
    };

    return (
      <li
        className="relative py-[15px]"
        onMouseEnter={() => !isMobile && setIsOpen(true)} // Hover behavior on desktop
        onMouseLeave={() => !isMobile && setIsOpen(false)} // Hover behavior on desktop
      >
        <a
          href={url}
          onClick={dropdownItems ? toggleDropdown : undefined} // Only prevent default on click if dropdown exists
          className={`max-md:px-[30px] relative inline-flex items-center justify-center px-[3px] py-[7px] after:content-[''] after:bottom-0 after:absolute  after:absolute after:h-[2px] after:left-0 after:bg-white after:transition-all after:duration-200 after:ease-in-out ${
            isOpen ? "after:w-[100%]" : "after:w-[0]"
          }`}
        >
          <div className="max-md:text-[16px] max-md:text-black text-[#fff] text-[14px] font-[500] font-primary leading-[130%]">
            {children}
          </div>
          {dropdownItems && (
            <span className="ml-[10px]">
              <svg
                version="1.1"
                width="11px"
                height="11px"
                viewBox="0 0 451.847 451.847"
                className={`transition-transform duration-200 md:[fill:#fff] ${
                  isOpen ? "rotate-180" : "rotate-0"
                }`}
              >
                <g>
                  <path
                    d="M225.923,354.706c-8.098,0-16.195-3.092-22.369-9.263L9.27,151.157c-12.359-12.359-12.359-32.397,0-44.751
                      c12.354-12.354,32.388-12.354,44.748,0l171.905,171.915l171.906-171.909c12.359-12.354,32.391-12.354,44.744,0
                      c12.365,12.354,12.365,32.392,0,44.751L248.292,345.449C242.115,351.621,234.018,354.706,225.923,354.706z"
                  />
                </g>
              </svg>
            </span>
          )}
        </a>
        {dropdownItems && (
          <ul
            className={`max-md:relative absolute md:top-full left-0 bg-white shadow-lg overflow-hidden z-10 min-w-[270px] border-t-[2px] border-t-[black] transition-all duration-300 ease-in-out ${
              isOpen
                ? "max-md:block opacity-100 md:mt-[0] visible"
                : "max-md:hidden opacity-0 md:mt-[20px] invisible"
            }`}
            style={{ overflow: "hidden" }} // Ensures content doesn't overflow during transition
          >
            {dropdownItems.map((item, index) => (
              <li
                key={index}
                className="border-b-[1px] border-b-[#ebebeb] hover:bg-gray-100 transition-all duration-200 ease-in-out"
              >
                <a
                  href={item.url}
                  className="flex px-[20px] py-[15px] items-center group"
                >
                  <svg
                    width="10px"
                    height="10px"
                    viewBox="-4.5 0 20 20"
                    version="1.1"
                    className="ml-[-7px] mr-[0] opacity-0 transition-all duration-300 ease-in-out group-hover:mr-[10px] group-hover:opacity-100"
                  >
                    <title>arrow_right [#336]</title>
                    <desc>Created with Sketch.</desc>
                    <defs></defs>
                    <g id="Page-1" stroke="none" fill="none">
                      <g
                        id="Dribbble-Light-Preview"
                        transform="translate(-305.000000, -6679.000000)"
                        fill="#000000"
                      >
                        <g
                          id="icons"
                          transform="translate(56.000000, 160.000000)"
                        >
                          <path
                            d="M249.365851,6538.70769 L249.365851,6538.70769 C249.770764,6539.09744 250.426289,6539.09744 250.830166,6538.70769 L259.393407,6530.44413 C260.202198,6529.66364 260.202198,6528.39747 259.393407,6527.61699 L250.768031,6519.29246 C250.367261,6518.90671 249.720021,6518.90172 249.314072,6519.28247 L249.314072,6519.28247 C248.899839,6519.67121 248.894661,6520.31179 249.302681,6520.70653 L257.196934,6528.32352 C257.601847,6528.71426 257.601847,6529.34685 257.196934,6529.73759 L249.365851,6537.29462 C248.960938,6537.68437 248.960938,6538.31795 249.365851,6538.70769"
                            id="arrow_right-[#336]"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </svg>
                  <Typography.Smp className="text-[#000]">
                    {item.label}
                  </Typography.Smp>
                </a>
              </li>
            ))}
          </ul>
        )}
      </li>
    );
  };

  const [isOpenNav, setIsOpenNav] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // Check if the screen width is below the 'md' breakpoint
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // md breakpoint is 768px
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Initial check on component mount

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <nav className="absolute z-[99] left-0 top-0 right-0">
      <div className="wrapper">
        <div className="max-md:py-[5px] max-md:px-[15px] max-md:w-[100%] max-md:fixed max-md:left-0 max-md:top-0 max-md:bg-black max-md:justify-end flex justify-between py-[12px] items-center">
          <div className="max-md:hidden flex flex-col gap-[3px] min-h-[40px] justify-center">
            <Typography.Smp className="text-white">
              Contact us before arrival
            </Typography.Smp>
            {comp?.opentime && (
              <Typography.Smp className="text-white">
                Working hours: {comp.opentime}
              </Typography.Smp>
            )}
          </div>
          <div>
            <ul className="flex gap-[18px] items-center justify-center">
              {comp?.facebook && (
                <li>
                  <Socm url={comp.facebook}>
                    <svg
                      alt="icon"
                      viewBox="0 0 512 510.125"
                      className="w-[15px]"
                    >
                      <path
                        fill="#fff"
                        d="M512 256C512 114.615 397.385 0 256 0S0 114.615 0 256c0 120.059 82.652 220.797 194.157 248.461V334.229h-52.79V256h52.79v-33.709c0-87.134 39.432-127.521 124.977-127.521 16.218 0 44.202 3.18 55.651 6.36v70.916c-6.042-.635-16.537-.954-29.575-.954-41.977 0-58.196 15.901-58.196 57.241V256h83.619l-14.365 78.229h-69.254v175.896C413.771 494.815 512 386.885 512 256z"
                      />
                    </svg>
                  </Socm>
                </li>
              )}
              {comp?.instagram && (
                <li>
                  <Socm alt="icon" url={comp.instagram}>
                    <svg viewBox="0 0 512 512" className="w-[15px]">
                      <path
                        fill="#fff"
                        d="M170.663 256.157c-.083-47.121 38.055-85.4 85.167-85.483 47.121-.092 85.407 38.03 85.499 85.16.091 47.129-38.047 85.4-85.176 85.492-47.112.09-85.399-38.039-85.49-85.169zm-46.108.091c.141 72.602 59.106 131.327 131.69 131.186 72.592-.141 131.35-59.09 131.209-131.692-.141-72.577-59.114-131.335-131.715-131.194-72.585.141-131.325 59.115-131.184 131.7zm237.104-137.091c.033 16.953 13.817 30.681 30.772 30.648 16.961-.033 30.689-13.811 30.664-30.764-.033-16.954-13.818-30.69-30.78-30.657-16.962.033-30.689 13.818-30.656 30.773zm-208.696 345.4c-24.958-1.087-38.511-5.234-47.543-8.709-11.961-4.629-20.496-10.178-29.479-19.094-8.966-8.95-14.532-17.46-19.202-29.397-3.508-9.032-7.73-22.569-8.9-47.527-1.269-26.982-1.559-35.077-1.683-103.432-.133-68.339.116-76.434 1.294-103.441 1.069-24.942 5.242-38.512 8.709-47.536 4.628-11.977 10.161-20.496 19.094-29.479 8.949-8.982 17.459-14.532 29.403-19.202 9.025-3.525 22.561-7.714 47.511-8.9 26.998-1.277 35.085-1.551 103.423-1.684 68.353-.132 76.448.108 103.456 1.295 24.94 1.086 38.51 5.217 47.527 8.709 11.968 4.628 20.503 10.144 29.478 19.094 8.974 8.95 14.54 17.443 19.21 29.412 3.524 9 7.714 22.553 8.892 47.494 1.285 26.999 1.576 35.095 1.7 103.433.132 68.355-.117 76.451-1.302 103.441-1.087 24.958-5.226 38.52-8.709 47.561-4.629 11.952-10.161 20.487-19.103 29.471-8.941 8.949-17.451 14.531-29.403 19.201-9.009 3.517-22.561 7.714-47.494 8.9-26.998 1.269-35.086 1.559-103.448 1.684-68.338.132-76.424-.125-103.431-1.294zM149.977 1.773c-27.239 1.285-45.843 5.648-62.101 12.018-16.829 6.561-31.095 15.354-45.286 29.604C28.381 57.653 19.655 71.944 13.144 88.79c-6.303 16.299-10.575 34.912-11.778 62.168C.172 178.264-.102 186.973.031 256.489c.133 69.508.439 78.234 1.741 105.547 1.302 27.231 5.649 45.828 12.019 62.093 6.569 16.83 15.353 31.088 29.611 45.288 14.25 14.201 28.55 22.918 45.404 29.438 16.282 6.295 34.902 10.583 62.15 11.778 27.305 1.203 36.022 1.468 105.521 1.335 69.532-.132 78.25-.439 105.555-1.733 27.239-1.303 45.826-5.665 62.1-12.019 16.829-6.586 31.095-15.353 45.288-29.611 14.191-14.251 22.917-28.55 29.428-45.405 6.304-16.282 10.592-34.903 11.777-62.134 1.195-27.322 1.478-36.048 1.344-105.556-.133-69.516-.447-78.225-1.741-105.523-1.294-27.255-5.657-45.844-12.019-62.118-6.577-16.829-15.352-31.079-29.602-45.287-14.25-14.192-28.55-22.935-45.404-29.429-16.29-6.305-34.903-10.601-62.15-11.779C333.747.164 325.03-.102 255.506.031c-69.507.133-78.224.431-105.529 1.742z"
                      />
                    </svg>
                  </Socm>
                </li>
              )}
              {comp?.youtube && (
                <li>
                  <Socm alt="icon" url={comp.youtube}>
                    <svg viewBox="0 0 512 360.726" className="w-[15px]">
                      <path
                        fill="#fff"
                        d="M456.035 10.769c22.031 5.926 39.377 23.386 45.265 45.56C512 96.516 512 180.363 512 180.363s0 83.846-10.7 124.037c-5.888 22.17-23.234 39.631-45.265 45.559-39.928 10.767-200.034 10.767-200.034 10.767s-160.107 0-200.035-10.767C33.937 344.031 16.587 326.57 10.7 304.4 0 264.209 0 180.363 0 180.363S0 96.516 10.7 56.329c5.887-22.174 23.237-39.634 45.266-45.56C95.894 0 256.001 0 256.001 0s160.106 0 200.034 10.769zm-252.398 245.72l133.818-76.122-133.818-76.131v152.253z"
                      />
                    </svg>
                  </Socm>
                </li>
              )}
              {comp?.tiktok && (
                <li>
                  <Socm alt="icon" url={comp.tiktok}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 448 512"
                      width="11px"
                      height="15px"
                    >
                      <path
                        fill="#fff"
                        d="M448 209.9a210.1 210.1 0 0 1 -122.8-39.3V349.4A162.6 162.6 0 1 1 185 188.3V278.2a74.6 74.6 0 1 0 52.2 71.2V0l88 0a121.2 121.2 0 0 0 1.9 22.2h0A122.2 122.2 0 0 0 381 102.4a121.4 121.4 0 0 0 67 20.1z"
                      ></path>
                    </svg>
                  </Socm>
                </li>
              )}
            </ul>
          </div>
        </div>
        <div className="max-md:top-[25px] max-md:left-0 max-md:fixed max-md:py-[5px] max-md:px-[15px] max-md:w-[100%] max-md:bg-white flex py-[20px] justify-between  items-center">
          <a
            href="/home"
            className="inline-flex items-center gap-[10px] max-xl:gap-[3px] max-xl:flex-col max-md:flex-row"
          >
            <img
              src="./imgs/logo-w.png"
              className={`max-xl:max-h-[70px] max-w-[200px] max-h-[80px] ${
                isMobile ? "hidden" : ""
              }`}
              alt="logo"
            />
            <img
              src="./imgs/logo.png"
              className={`max-w-[200px] max-h-[60px] ${
                isMobile ? "" : "hidden"
              }`}
              alt="logo"
            />
            <Typography.BoxName className="max-md:font-medium max-md:text-black text-white font-light max-xl:text-[14px]">
              Apocalypse Girl
            </Typography.BoxName>
          </a>
          <div
            className="md:hidden flex flex-col gap-[5px]"
            onClick={() => setIsOpenNav(!isOpenNav)}
          >
            <div
              className={`w-[30px] h-[2px] bg-black rounded-[2px] transition-all duration-150 ease-in-out ${
                isOpenNav ? "rotate-45" : "rotate-0"
              }`}
            ></div>
            <div
              className={`w-[30px] h-[2px] bg-black rounded-[2px] transition-all duration-150 ease-in-out ${
                isOpenNav
                  ? "rotate-45 mt-[-7px] opacity-0"
                  : "rotate-0 mt-[0] opacity-100"
              }`}
            ></div>
            <div
              className={` h-[2px] bg-black rounded-[2px] transition-all duration-150 ease-in-out ${
                isOpenNav
                  ? "-rotate-45 w-[30px] mt-[-6px]"
                  : "rotate-0 w-[25px] mt-[0]"
              }`}
            ></div>
          </div>
          <ul
            className={`max-md:overflow-auto max-md:gap-[0px] max-md:shadow-xl max-md:w-[280px] max-md:border-t-[1px] max-md:border-b-[#ebebeb] max-md:h-[calc(100vh-95px)] max-md:right-0 max-md:flex-col max-md:bg-white max-md:top-[95px] max-md:fixed max-xl:gap-[15px] flex gap-[30px]  transition-all duration-300 ease-in-out ${
              isOpenNav ? "max-md:mr-0" : "max-md:mr-[-280px]"
            }`}
          >
            {NavBarList.map((item, index) =>
              item.dropdownItems ? (
                <NavUrl
                  key={index}
                  url={item.url}
                  dropdownItems={item.dropdownItems}
                >
                  {item.label}
                </NavUrl>
              ) : (
                <NavUrl key={index} url={item.url}>
                  {item.label}
                </NavUrl>
              )
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default NavBarT1;
